import { Link } from "react-router-dom";
import { specials } from "@/mocks/specials";

export default function SpecialsPreview() {
  return (
    <section id="specials" className="mx-auto max-w-7xl px-4 py-12 md:px-8 md:py-16">
      <div className="mb-8 flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="font-heading text-2xl font-extrabold text-foreground-950 md:text-3xl">
            精选专题合集
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            围绕同一主题整理的视频合集，一次看个过瘾
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
        {specials.map((s, i) => (
          <Link
            key={s.id}
            to={`/special/${s.id}`}
            className="group relative flex h-64 animate-fadeUp flex-col justify-end overflow-hidden rounded-lg border border-background-200"
            style={{ animationDelay: `${i * 80}ms` }}
          >
            <img
              src={s.cover}
              alt={s.title}
              title={`${s.title} - 糖心Vlog 专题`}
              className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/30 to-transparent" />
            <div className="relative p-5">
              <span className="inline-flex items-center gap-1 rounded-md bg-background-50/90 px-2 py-0.5 text-xs font-medium text-primary-700">
                <i className="ri-price-tag-3-line" /> {s.videoIds.length} 个视频
              </span>
              <h3 className="mt-3 font-heading text-lg font-bold text-background-50">{s.title}</h3>
              <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-background-100/90">
                {s.intro}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}